// Hooks
import { useHistory } from "react-router-dom";
import { useFormContext } from "react-hook-form";

// Helpers
import { handleReset } from "@common/components/helpers/reset";
import { handleResetForDesktop } from "../helpers/reset";
import { handleError } from "../helpers/error";

// Actions
import LoadingAction from "@common/redux/actions/LoadingAction";
import AlertModalAction from "@common/redux/actions/AlertModalAction";
import PhotoAction from "@common/redux/actions/PhotoAction";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";
import CustomerInteractionAction from "@common/redux/actions/CustomerInteractionAction";
import CustomerAction from "@common/redux/actions/CustomerAction";
import CustomerIncidentAction from "@common/redux/actions/CustomerIncidentAction";
import OfficerAction from "@common/redux/actions/OfficerAction";
import OfficerFormModalAction from "@common/redux/actions/OfficerFormModalAction";
import ObservationsAction from "@common/redux/actions/ObservationsAction";
import LinkSessionAction from "@common/redux/actions/LinkSessionAction";
import LinkAlertAction from "@common/redux/actions/LinkAlertAction";
import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";
import SessionalPositionsAction from "@common/redux/actions/SessionalPositionsAction";
import UnresolvedDisputeAction from "@common/redux/actions/UnresolvedDisputeAction";
import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";
import AgeVerificationAction from "@common/redux/actions/AgeVerificationAction";
import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";
import useLogin from "./useLogin";

const useCompliance = (formMethods = null) => {
  const history = useHistory();
  const [{ isDesktop }] = useLogin();
  const formContext = useFormContext();
  const { reset, setValue } = formContext ?? formMethods ?? {};

  const resetComplianceActions = [
    ...(reset ? [reset] : []),
    PhotoAction.reset,
    CustomerFormAction.reset,
    CustomerInteractionAction.reset,
    CustomerAction.reset,
    CustomerIncidentAction.reset,
    SuspiciousActivityAction.reset,
    OfficerAction.reset,
    OfficerFormModalAction.reset,
    ObservationsAction.reset,
    UnresolvedDisputeAction.reset,
    LinkSessionAction.reset,
    LinkAlertAction.reset,
    SessionalDetailsAction.reset,
    SessionalPositionsAction.reset,
    AgeVerificationAction.reset,
    IdentityFormModalAction.reset,
  ];

  const resetComplianceForms = (redirect = true) => {
    handleReset(...resetComplianceActions);
    redirect && history.push("/compliance");
  };

  const submitComplianceForm = ({
    client,
    payload,
    resetForm,
    callback = () => {},
    desktopCallback = () => {},
  }) => {
    const fnSubmit = isDesktop ? client.Update : client.Create;

    LoadingAction.set(true).then(() =>
      fnSubmit(payload)
        .then((response) => {
          callback();
          AlertModalAction.open(
            `The form was successfully submitted!`,
            "Success",
            isDesktop ? () => {} : () => history.push("/compliance"),
          );
          if (!isDesktop) {
            resetForm(true);
          } else {
            desktopCallback(response);
            setValue("rowVersion", response.rowVersion);
            handleResetForDesktop();
          }
        })
        .catch((error) => {
          console.error(error);
          handleError(
            error,
            "Errors",
            "There is an error submitting the form.",
          );
        })
        .finally(() => {
          LoadingAction.set(false);
        }),
    );
  };

  return { resetComplianceActions, resetComplianceForms, submitComplianceForm };
};

export default useCompliance;
